import { ProtectedRoute } from '@components/protectedRoute';
import { buildersRoute as route } from '@utils/consts';
import { Outlet } from 'react-router';

const routes = [
  {
    path: route.index,
    lazy: async () => {
      return {
        Component: () => (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
      };
    },
    children: [
      {
        path: '',
        lazy: async () => {
          const { Builders } = await import('@pages/builders');
          return {
            Component: () => <Builders />,
          };
        },
      },
      {
        path: route.builder(),
        lazy: async () => {
          const { Builder } = await import('@pages/builders/_id');
          return {
            Component: () => <Builder />,
          };
        },
      },
    ],
  },
];

export { routes as buildersRoutes };
